import { render, staticRenderFns } from "./DeployedWorkloadControl.vue?vue&type=template&id=6069ba7e"
import script from "./DeployedWorkloadControl.vue?vue&type=script&lang=js"
export * from "./DeployedWorkloadControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports